const scrollToAbschnitt = (hash, behavior = 'smooth') => {
	const target = document.querySelector(`.abschnitt[anchor="${hash}"]`);
	if (target) window.scrollTo({ top: target.getBoundingClientRect().top+scrollY-20, behavior });
	return target;
};

if (document.querySelector('.abschnitt')) {
	document.querySelectorAll('nav a[href*="#"]').forEach(link => {
		link.onclick = e => {
			const url = link.getAttribute('href');
			const hash = url.split('#')[1];
			if (hash && scrollToAbschnitt(hash)) {
				e.preventDefault();
				history.pushState({}, document.title+' | '+hash, url);
			}
		};
	});

	window.addEventListener('DOMContentLoaded', () => {
		if (location.hash) scrollToAbschnitt(location.hash.substring(1), 'auto');
	});
}
